class Content {
  constructor(){
    this.pages=[
      {
        id:0,
        en:"home",
        fr:"d'accueil",
        content:[
          {
            id:"front-text",
            en:"is a premium line of dental health products designed to fight plaque, tartar and freshen breath.",
            fr:"est une gamme de produits de santé bucco-dentaire de qualité conçue pour combattre la plaque, le tartre et rafraîchir l'haleine.",
            us_alt:"is a premium line of oral health products designed to fight plaque and tartar."

          },
          {
            id:"oral_care_headline",
            en:"Vetradent™ Dental Health",
            fr:"Santé bucco-dentaire Vetradent™",
            us_alt:"Vetradent™ Dental Health"
          },
          {
            id:"oral_care_text",
            en:"Vetradent™ is a premium line of dental health products designed to fight plaque, tartar and freshen breath. \n\n The active ingredients in Vetradent™ bind to magnesium, calcium and iron found within dental biofilm. This effectively removes the bacteria’s food source and weakens the tartar.\n\nSatisfaction guaranteed.",
            fr:"Vetradent™ est une gamme de produits de santé bucco-dentaire de qualité conçue pour combattre la plaque, le tartre et rafraîchir l'haleine. \n\n Les ingrédients actifs de Vetradent™ se lient au magnésium, calcium et fer trouvés dans le biofilm dentaire. Ceci élimine efficacement les bactéries d’origine alimentaire et affaiblit le tartre.\n\nSatisfaction garantie.",
            us_alt:"Vetradent™ is a premium line of oral health products designed to fight plaque, tartar and freshen breath. \n\n The active ingredients in Vetradent™ bind to magnesium, calcium and iron found within dental biofilm. This effectively removes the bacteria’s food source and weakens the tartar.\n"

          },
          {
            id:"action-item",
            en:"See the full line",
            fr:"Voir les produits",
            us_alt:""

          },
          {
            id:"testimony_headline",
            en:"What vets are saying:",
            fr:"Ce que les vétérinaires disent :",
            us_alt:"What vets are saying:"

          },
          {
            id:"testimony_text",
            en:"The Vetradent wipes are my number one recommended dental product to control plaque and tartar.",
            fr:"Les lingettes Vetradent sont mon produit dentaire recommandé numéro un pour contrôler la plaque et le tartre.",
            us_alt:"The Vetradent wipes are my number one recommended dental product to control plaque and tartar."

          },
          {
            id:"testimony_subtext",
            en:"- Jan Bellows, DVM, Dipl. AVDC, ABVP",
            fr:"- Jan Bellows, DMV, Dipl. AVDC, ABVP",
            us_alt:"- Jan Bellows, DVM, Dipl. AVDC, ABVP"

          },
          {
            id:"select_feature_headline",
            en:"Click on feature for more information:",
            fr:"Cliquez sur caractéristiques pour plus d'informations :",
            us_alt:"Click on feature for more information:"

          },
          {
            id: "features",
            content: [
              {
                id:"effective",
                class:"canWrap",
                en: "Demonstrated Efficacy",
                fr: "Efficacité démontrée",
                us_alt: "Demonstrated Efficacy"
              },


              {
                id:"effective_text",
                en: "It is unique because it works against dental disease-associated bacteria by altering the mouth’s environment. During testing, veterinarians found 92% of dogs using Vetradent™ showed significant improvement in their dental health and oral hygiene.",
                fr: "C’est un produit unique parce qu'il agit contre les bactéries associées à la maladie dentaire en modifiant l'environnement buccal. Au cours des essais, les vétérinaires ont trouvé que 92 % de chiens utilisant Vetradent™ ont démontré une amélioration significative de leur santé dentaire et hygiène buccale.",
                us_alt: "Vetradent products are unique because they work against dental disease-associated bacteria by altering the mouth’s environment. During testing, veterinarians found 92% of dogs using Vetradent™ showed significant improvement in their dental health and oral hygiene."
              },


              {
                id:"safe",
                class:"canWrap",
                en: "Demonstrated Safety",
                fr: "Sécurité démontrée",
                us_alt: "Demonstrated Safety"
              },


              {
                id:"safe_text",
                en: "Vetradent™  has been demonstrated to be safe in a 30 day safety study in dogs and cats . Made with Biotrate™ patent-pending technology, Vetradent™ uses food grade ingredients that are safe for everyday consumption.",
                fr: "Vetradent™ a été démontré comme sûr par une étude de sûreté de 30 jours chez le chien et le chat. Conçu de la technologie  Biotrate™, en attente de brevet, Vetradent™ utilise des ingrédients de qualité alimentaire qui sont sécuritaires pour la consommation courante.",
                us_alt: "Vetradent™ has been demonstrated to be safe in a 30 day safety study in 18 healthy, adult dogs and 18 healthy, adult cats. Made with Biotrate™ patent-pending technology, Vetradent™ uses food grade ingredients that are safe for everyday consumption. Please contact our Veterinary Technical Support Team for full safety study information."
              },


              {
                id:"easy",
                class:"canWrap",
                en: "Easy to Use",
                fr: "Facilité d’utilisation",
                us_alt: "Easy to Use"
              },


              {
                id:"easy_text",
                en: "Just like caring for our own teeth is an everyday function, the same goes for dogs and cats. It’s important to select a routine that you, as a pet owner, can conveniently take care of every day. Vetradent™ is available in 5 different formulations: Liquid Water Additive, Powder Water Additive, Oral Spray, Toothpaste and new Dental Wipes. Vetradent™ products are available through your veterinarian.",
                fr: "Prendre soin de vos propres dents est une tâche quotidienne ; il en est de même pour les chiens et les chats. Il est important de choisir une routine que vous, en tant que propriétaire d'un animal de compagnie, puissiez facilement effectuer tous les jours. Vetradent™ est disponible en 5 formules différentes : Additif pour l’eau, additif en poudre, vaporisateur oral, dentifrice et les nouvelles lingettes dentaires. Les produits Vetradent™ sont disponibles auprès de votre vétérinaire.",
                us_alt: "Just like caring for our own teeth is an everyday function, the same goes for dogs and cats. It’s important to select a routine that you, as a pet owner, can conveniently take care of every day. Vetradent™ is available in 3 different formulations, Liquid Water Additive, Oral Spray, and Dental Wipes.  Vetradent™ products are available through your veterinarian."
              },


              {
                id:"bad_breath",
                class:"canWrap",
                en: "Reduces Halitosis",
                fr: "Réduit l'halitose",
                us_alt: "Reduces Halitosis"
              },

              {
                id:"bad_breath_text",
                en: "Without proper treatment, odor-producing bacteria can build up in your pet’s mouth. Dogs using Vetradent™ experienced up to an 82% reduction in halitosis (bad breath).",
                fr: "Sans traitement approprié, les bactéries productrices d'odeurs peuvent s'accumuler dans la bouche de votre animal. Les chiens utilisant Vetradent™ ont démontré jusqu'à 82 % de réduction de l'halitose (mauvaise haleine).",
                us_alt: "Without proper treatment, odor-producing bacteria can build up in your dog’s mouth. Dogs in a clinical study with Vetradent™ experienced up to an 82% reduction in halitosis."
              },


              {
                id:"cutting",
                class:"canWrap",
                en: "Cutting Edge Mode of Action",
                fr: "Mode d'action de pointe",
                us_alt: "Cutting Edge Mode of Action"
              },

              {
                id:"cutting_text",
                en: "When Vetradent™ enters the pet’s mouth, its binding agents immediately attach to the magnesium, calcium and iron, and wash them away – effectively removing the bacteria’s food source and weakening the tartar.",
                fr: "Quand Vetradent™ entre dans la bouche de l'animal, ses agents de liaison s’attachent immédiatement au magnésium, calcium et fer, et les font disparaitre, éliminant efficacement les bactéries d’origine alimentaire et affaiblissant le tartre.",
                us_alt: "When Vetradent™ enters the pet’s mouth, its binding agents immediately attach to the magnesium, calcium and iron, and wash them away – effectively removing the bacteria’s food source and weakening the tartar."
              }





            ]
          }
        ]
      },
      {
        id:1,
        en:"How It Works",
        fr:"Comment cela fonctionne",
        us_alt:"How It Works",
        content:[
          {
            id:"headline",
            en:"Biofilms",
            fr:"Biofilms",
            us_alt:"Biofilms"
          },
          {
            id:"headline-text",
            en:"Biofilms are structured communities of microorganisms enclosed in a matrix of complex sugars, or polysaccharides. About 99% of all bacteria live in biofilm communities. These communal bacteria are 100 to 1000 times more resistant to antibiotics and antimicrobials compared with free floating bacterial cells.",
            fr:"Les biofilms sont des communautés structurées de microorganismes emprisonnées dans une matrice de sucres complexes, les polysaccharides. Environ 99 % de toutes les bactéries vivent dans de tels biofilms. Ces bactéries communautaires sont 100 à 1000 fois plus résistantes aux antibiotiques et antimicrobiens en comparaison des cellules bactériennes flottant librement.",
            us_alt:"Biofilms are structured communities of microorganisms enclosed in a matrix of complex sugars, or polysaccharides. About 99% of all bacteria live in biofilm communities. These communal bacteria are 100 to 1000 times more resistant to antibiotics and antimicrobials compared with free floating bacterial cells."
          },
          {
            id:"step-1",
            en:"Step 1:",
            fr:"Étape 1 :",
            us_alt:"Step 1:"
          },
          {
            id:"step-1-text",
            en:"A pet’s saliva along with any food debris on their teeth contain magnesium, calcium and iron – the food source for bacteria.",
            fr:"Les bactéries se nourrissent du magnésium, du calcium et du fer contenus dans la salive d’un animal et les débris d’aliments présents sur ses dents.",
            us_alt:"A pet’s saliva, along with any food debris on the teeth, contains magnesium, calcium and iron – the food source for bacteria."
          },
          {
            id:"step-2",
            en:"Step 2:",
            fr:"Étape 2 :",
            us_alt:"Step 2:"
          },
          {
            id:"step-2-text",
            en:"As bacteria is attracted to this food source, it attaches to the tooth’s surface and produces a protective dome called a biofilm, under which the bacteria rapidly multiply to create a colony. This yellow, gooey substance is plaque.",
            fr:"Les bactéries attirées par cette source d’aliments se fixent sur la surface des dents de l’animal et fabriquent une structure protectrice appelée biofilm, sous laquelle les bactéries se multiplient rapidement pour créer une colonie. Cette substance jaune et gluante est la plaque.",
            us_alt:"As bacteria are attracted to this food source, they attach to the tooth’s surface and produces a protective dome called a biofilm, under which the bacteria rapidly multiply to create a colony. This yellow, gooey substance is plaque."
          },
          {
            id:"step-3",
            en:"Step 3:",
            fr:"Étape 3 :",
            us_alt:"Step 3:"
          },
          {
            id:"step-3-text",
            en:"After a while some bacteria will break free to start other colonies, which progresses the formation of plaque.",
            fr:"Après un certain temps, quelques bactéries se détachent et vont former de nouvelles colonies qui elles activeront la formation de plaque.",
            us_alt:"After a while some bacteria will break free to start other colonies, which progresses the formation of plaque."
          },
          {
            id:"step-4",
            en:"Step 4:",
            fr:"Étape 4 :",
            us_alt:"Step 4:"
          },
          {
            id:"step-4-text",
            en:"Eventually the plaque calcifies and turns into an extremely hard substance called tartar. Bacteria continue to build layers of plaque and calcified tartar.",
            fr:"Eventuellement, la plaque finit par se calcifier et par se transformer en une substance extrêmement dure appelée tartre. Les bactéries continuent à déposer des couches de plaque et de tartre calcifiés.",
            us_alt:"Eventually the plaque calcifies and turns into an extremely hard substance called tartar (sometimes called calculus). Bacteria continue to build layers of plaque and calcified tartar."
          },
          {
            id:"step-5",
            en:"Step 5:",
            fr:"Étape 5 :",
            us_alt:"Step 5:"
          },
          {
            id:"step-5-text",
            en:"When Vetradent enters the pet’s mouth, its binding agents immediately attach to the magnesium, calcium and iron, and wash them away – effectively removing the bacteria’s food source and weakening the tartar.",
            fr:"Lorsque Vetradent™ pénètre la bouche de l’animal, ses agents actifs se fixent immédiatement au magnésium, au calcium et au fer et les élimine avec efficacité la source alimentaire des bactéries ce qui affaiblit le tartre.",
            us_alt:"When Vetradent enters the pet’s mouth, its binding agents immediately attach to the magnesium, calcium and iron, and wash them away – effectively removing the bacteria’s food source and weakening the tartar."
          },
          {
            id:"step-6",
            en:"Step 6:",
            fr:"Étape 6 :",
            us_alt:"Step 6:"
          },
          {
            id:"step-6-text",
            en:"Without this food source the bacteria have nothing to live on and colonies become weak. Eventually the layers of plaque and tartar buildup begin to soften. The tartar can then easily flake and break off.",
            fr:"Privées de cette source d’aliments, les bactéries ne peuvent survivre et les colonies s’affaiblissent . Après un certain temps, les couches de plaque et de tartre accumulées commencent à ramollir. Par la suite, le tartre se désagrège et s’effrite facilement.",
            us_alt:"Without this food source the bacteria have almost nothing to live on and colonies become weak. Eventually the layers of plaque and tartar buildup begin to soften. The tartar can then easily flake and break off."
          },
          {
            id:"what-matters",
            en:"What Matters",
            fr:"Ce qui importe",
            us_alt:"What Matters"
          },
          {
            id:"what-matters-efficacy",
            en:"Efficacy",
            fr:"Efficacité",
            us_alt:"Efficacy"
          },
          {
            id:"what-matters-efficacy-text",
            en:"Sixty healthy beagle dogs took part in a controlled, randomized, masked Good Clinical Practice (GCP) study. Thirty dogs were given Vetradent™ treated drinking water, and thirty dogs received no Vetradent™ in their water, as they formed the control group. At the beginning of the study all of the dogs had their teeth cleaned. On day 0, the tartar of each dog was scored. The dogs then drank the treated Vetradent™ water at the recommended dose for 84 days. The tartar was scored on days 28, 56, and 84. The mean tartar scores for the Vetradent™ treated dogs were lower than the control group for the duration of the study.",
            fr:"Soixante chiens beagles en santé ont participé à une étude contrôlée sur échantillon aléatoire selon les bonnes pratiques cliniques (BPC). Trente chiens ont reçu de l’eau de boisson traitée avec Vetradent™ et trente chiens ont reçu de l’eau sans Vetradent™ (groupe témoin). Au début de l’étude, les dents de tous les chiens ont été nettoyées. Au jour 0, le tartre de chacun des chiens a été évalué selon le grade. Les chiens ont par la suite commencé à boire l’eau traitée avec Vetradent™ ajouté à la dose recommandée pendant 84 jours. Le tartre a été coté aux jours 28, 56 et 84. Pour la durée de l’étude l’indice de tartre attribué aux chiens traités avec Vetradent™ était 25,4 % inférieur à celui attribué au groupe témoin.",
            us_alt:"Sixty healthy beagle dogs took part in a controlled, randomized, masked Good Clinical Practice (GCP) study*. Thirty dogs were given Vetradent™ treated drinking water, and thirty dogs received no Vetradent™ in their water, as they formed the control group. At the beginning of the study all dogs had their teeth professionally cleaned under anesthesia. On day 0, the tartar of each dog was scored. The dogs then drank the treated Vetradent™ water at the recommended dose for 84 days. The tartar was scored on days 28, 56, and 84. The mean tartar scores for the Vetradent™ treated dogs were lower than the control group for the duration of the study."
          },
          {
            id:"efficacy-footnote",
            en:"",
            fr:"",
            us_alt:"*Study summary available upon request"

          },
          {
            id:"what-matters-results",
            en:"Results",
            fr:"Résultats",
            us_alt:"Results"
          },
          {
            id:"what-matters-results-text",
            en:"The tartar score for the Vetradent™ treated dogs was 25.4% lower than the control group. The difference between the two groups was significant (p<0.03). The study demonstrated that Vetradent™ is effective in decreasing dental tartar in dogs.",
            fr:"L’indice de tartre attribué aux chiens traités avec Vetradent™ était 25,4 % inférieur à celui attribué au groupe témoin. La différence entre les deux groupes était significative (p<0,03). L’étude a démontré que Vetradent™ est efficace pour prévenir le tartre chez les chiens.",
            us_alt:"The tartar score for the Vetradent™ treated dogs was 25.4% lower than the control group at the conclusion of the study. The difference between the two groups was statistically significant (p<0.03). The study demonstrated that Vetradent™ is effective in decreasing dental tartar in dogs."
          },
          {
            id:"what-matters-conclusion",
            en:"The tartar score for the Vetradent™ treated dogs was 25.4% lower than the control group.",
            fr:"L’indice de tartre attribué aux chiens traités avec Vetradent™ était 25,4 % inférieur à celui attribué au groupe témoin.",
            us_alt:"The tartar score for the Vetradent™ treated dogs was 25.4% lower than the control group."
          },
          {
            id:"safety-headline",
            en:"Safety",
            fr:"Innocuité",
            us_alt:"Safety"
          },
          {
            id:"safety-text",
            en:"To determine the safety of Vetradent™ Water Additive in dogs, a controlled, randomized Good Scientific Practice (GSP) study was performed. The study was conducted over 30 days with one control and two treatment groups which received 1X or 5X the recommended Vetradent™ dose.\n\nClinical observations, oral assessments, body weight measurements, and clinical pathology analysis were performed during the study. Dogs were observed daily for food intake, general appearance, and feces. Bi-weekly body weight measurements were taken, and samples for blood, serum, and coagulation were collected on days 1, 14, and 29.",
            fr:"Afin de déterminer l’innocuité de l’additif pour l’eau Vetradent™ chez les chiens, une étude sur échantillon aléatoire, en conditions contrôlées a été réalisée selon les bonnes pratiques scientifiques. L’étude, d’une durée de 30 jours, comportait un groupe témoin et deux groupes de traitement recevant une fois et cinq fois la dose recommandée de Vetradent™.\n\nDes observations cliniques, des évaluations buccales, des mesures de poids corporel et des analyses de pathologie cliniques ont été réalisées au cours de l’étude. La consommation alimentaire, l’apparence générale et les fèces des chiens ont fait l’objet d’observations quotidiennes. Des mesures de poids corporel ont été prises aux deux semaines et des prélèvements pour analyses sanguines, épreuves sérologiques et épreuves de coagulation ont été effectuées aux jours 1, 14 et 29.",
            us_alt:"To determine the safety of Vetradent™ Water Additive in dogs, a controlled, randomized Good Scientific Practice (GSP) study was performed*. The study was conducted over 30 days with one control and two treatment groups which received 1X or 5X the recommended concentration of Vetradent™ in their water.\n\nClinical observations, oral assessments, body weight measurements, and clinical pathology analyses were performed during the study. Dogs were observed daily for food intake, general appearance, and feces. Bi-weekly body weight measurements were taken, and samples for complete blood cell counts, serum chemistry and coagulation were collected on days 1, 14, and 29."
          },
          {
            id:"safety-footnote",
            en:"",
            fr:"",
            us_alt:"*Study summary available upon request"

          },
          {
            id:"results-headline",
            en:"Results",
            fr:"Résultats",
            us_alt:"Results"
          },
          {
            id:"results-text",
            en:"Clinical observations, physical exams, and oral assessment revealed no evidence of adverse effects related to the consumption of Vetradent™ Water Additive. The study demonstrated the safety of Vetradent™ Water Additive at 1X and 5X’s the recommended dose.",
            fr:"Les observations cliniques, l’examen physique et l’évaluation buccale n’ont révélé aucun signe d’effet indésirable associé à la consommation de Vetradent™. Cette étude a montré l’innocuité de l’additif pour l’eau Vetradent™ utilisé à une et cinq fois la dose recommandée.",
            us_alt:"Clinical observations, physical exams, and oral assessment revealed no evidence of adverse effects related to the consumption of Vetradent™ Water Additive. The study demonstrated the safety of Vetradent™ Water Additive at 1X and 5X’s the recommended concentration."
          },
          {
            id:"results-conclusion",
            en:"Demonstrated safe at 5x’s the recommended dose",
            fr:"Démontré sans danger à 5 fois la dose recommandée",
            us_alt:"Demonstrated safe for dogs at 5x’s the recommended dose"
          },
          {
            id:"lrvhp-headline",
            en:"LRVHP",
            fr:"LRVHP",
            us_alt:""
          },
          {
            id:"lrvhp-text",
            en:"All Vetradent™ products are registered with Health Canada’s Low Risk Veterinary Health Products (LRVHP) program. LRVHP has a list of products that are considered to be admissible substances. They represent a low risk when used appropriately, and Health Canada considers it unlikely that they will pose a health risk to animals.",
            fr:"Tous les produits Vetradent™ sont approuvés en vertu du programme des produits vétérinaires de santé à faible risque (PVSFR) de Santé Canada. Pour obtenir plus d’information sur les substances admissibles figurant sur la liste des PVSFR, cliquez ici. Les substances admissibles sont celles qui représentent un faible risque quand elles sont utilisées de façon appropriée et Santé Canada estime qu’il est peu probable qu’elles puissent présenter un risque pour la santé des animaux.",
            us_alt:""
          },
          {


            content:[
              {
                id:"ingredients-headline",
                en:"Ingredient listing",
                fr:"Liste d’ingrédients ",
                us_alt:"Ingredient listing",

              },


              {
                id: "ingredients-active-headline",
                en: "Active Ingredients",
                fr: "Ingrédients actifs",
                us_alt: "Active Ingredients"
              },


              {
                id: "active-ingredient-1",
                en: "Sodium Citrate – A chelating agent.",
                fr: "Citrate de sodium – Un agent chélateur.",
                us_alt: "Sodium Citrate – A chelating agent."
              },
              {
                id: "active-ingredient-2",
                en: "Citric Acid – Exerts antibacterial activity against microbial plaque deposits and buffers pH in pet’s mouth.",
                fr: "Acide citrique – Exerce une activité antimicrobienne contre les dépôts de plaque et tampon de pH pour éviter tout déséquilibre dans la bouche de l'animal.",
                us_alt: "Citric Acid – pH buffer to ensure there is no change to the pH balance in the pets mouth"
              },
              {
                id: "active-ingredient-3",
                en: "Zinc Chloride – A mineral able to bind to volatile sulfur compounds which reduces bad breath.",
                fr: "Chlorure de zinc – Un minéral capable de lier les composés sulfurés volatils, ce qui réduit la mauvaise haleine.",
                us_alt: "Zinc Chloride – A mineral able to bind to volatile sulfur compounds which reduces bad breath"
              },

              {
                id: "ingredients-inactive-headline",
                en: "Non-Medicinal Ingredients",
                fr: "Ingrédients non médicinaux",
                us_alt: "Also Contains"
              },


              {
                id: "inactive-ingredient-1",
                en: "Potassium Benzoate – Preservative approved and required by Health Canada.",
                fr: "Benzoate de potassium – Un agent de conservation approuvé et exigé par Santé Canada.",
                us_alt: "Potassium Benzoate"
              },
              {
                id: "inactive-ingredient-2",
                en: "Disodium EDTA – Preservative approved and required by Health Canada.",
                fr: "EDTA disodique – Un agent de conservation approuvé et exigé par Santé Canada.",
                us_alt: "Disodium EDTA"

              },

              {
                id: "ingredients-maybe-contained-headline",
                en: "",
                fr: "",
                us_alt: "May Contain"
              },

              {
                id: "maybe-contained-ingredients",
                en: "",
                fr: "",
                us_alt: "Water, Sorbitol, Hydrated Silica, Glycerin, Chicken Flavour, Sodium Carboxymethyl cellulose, Potassium Sorbate."
              }
            ]
          }
        ]
      },
      {
        id:2,
        en:"Dental Health",
        fr:"Santé bucco-dentaire",
        us_alt:"Dental Health",
        content:[
          {
            id:"headline",
            en:"Make It Routine",
            fr:"En faire une routine",
            us_alt:"Make It Routine"
          },
          {
            id:"headline-text",
            en:"Just like caring for our own teeth is an everyday function, the same goes for dogs and cats. Adopt a daily dental treatment routine for your pets and take them into the clinic for regular dental check-ups. If any clinical signs of dental disease are present, consider scheduling a professional dental cleaning.",
            fr:"Comme Prendre soin de vos propres dents est une tâche quotidienne ; il en est de même pour les chiens et les chats. Adopter une routine quotidienne de traitement dentaire pour vos animaux et amenez-les en clinique pour des examens dentaires réguliers. Si des signes cliniques de maladie dentaire sont présents, envisager de planifier un nettoyage dentaire professionnel.",
            us_alt:"Just like caring for our own teeth is an everyday function, the same goes for dogs and cats. Adopt a daily dental treatment routine for your pets and take them into the clinic for regular dental check-ups. If any clinical signs of dental disease are present, consider scheduling a professional dental cleaning."
          },

          {
            id:"recognize-headline",
            en:"How to Recognize Dental Disease",
            fr:"Comment reconnaître les maladies dentaires",
            us_alt:"How to Recognize Dental Disease"
          },

          {
            id:"recognize-text",
            en:"Canine periodontitis is a bacterial infection of the mouth. Watch for the early signs of infection, such as inflamed gums, tartar build-up or foul-smelling breath. Even what is thought of as typical bad breath can be a sign of dental disease.\n\nDental disease is a progressive disease, the earlier it is identified and treated the greater the chance of minimizing the advancement of the disease.",
            fr:"La parodontite canine est une infection bactérienne de la bouche. Soyez vigilant pour les premiers signes d'infection, tels que l'inflammation des gencives, l'accumulation de tartre ou l’haleine nauséabonde. Même ce qui est considéré comme l’haleine typique d’un animal peut être un signe de maladie parodontale.\n\nLa maladie parodontale est une maladie progressive ; plus elle est identifiée et traitée tôt, plus grandes sont les chances de réduire la progression de la maladie.\n",
            us_alt:"Canine periodontitis is a bacterial infection of the mouth. Watch for the early signs of infection, such as inflamed gums, tartar build-up or foul-smelling breath. Even what is thought of as typical dog breath can be a sign of dental disease.\n\nDental disease is a progressive disease, the earlier it is identified and treated the greater the chance of minimizing the advancement of the disease."
          },
          {
            id:"matters-headline",
            en:"Why it Matters",
            fr:"Pourquoi est-ce important",
            us_alt:"Why it Matters"
          },
          {
            id:"matters-text",
            en:"Dental disease causes discomfort and can lead to diminished appetite and weight loss. As well, bacteria from dental disease or their toxins can travel into your pet’s bloodstream, affecting the lungs, heart, kidneys, liver and nervous system.",
            fr:"Les maladies dentaires causent de l'inconfort et peuvent entrainer à une diminution de l'appétit et la perte de poids. Ainsi, les bactéries de maladie dentaire ou leurs toxines peuvent passer dans le sang de votre animal, affectant les poumons, le cœur, les reins, le foie et le système nerveux.",
            us_alt:"Dental disease causes discomfort and can lead to diminished appetite and weight loss. As well, bacteria from dental disease can travel into your pet’s bloodstream, affecting the lungs, heart, kidneys, liver and nervous system."
          },
          {
            id:"how-headline",
            en:"How Vetradent™ Helps",
            fr:"Comment Vetradent™ aide",
            us_alt:"How Vetradent™ Helps"
          },
          {
            id:"how-text",
            en:"Vetradent™ has been demonstrated to be effective in maintaining and promoting good oral hygiene. Made with patent-pending Biotrate™ technology, Vetradent™ uses food grade ingredients that are safe for everyday consumption. Satisfaction guaranteed.",
            fr:"Vetradent™ a été démontré efficace dans le maintien et la promotion d'une bonne hygiène bucco-dentaire. Conçu de la technologie Biotrate™,en attente de brevet, Vetradent™ utilise des ingrédients alimentaires de haute qualité qui sont sécuritaires pour la consommation quotidienne. Satisfaction Garantie.",
            us_alt:"Vetradent™ has been demonstrated to be effective in maintaining and promoting good oral hygiene. Made with patent-pending Biotrate™ technology, Vetradent™ uses food grade ingredients."
          }
        ]
      },
      {
        id:3,
        en:"Products",
        fr:"Produits",
        us_alt:"Products",
        content:[
          {
            id:"headline",
            en:"With Biotrate™ Technology",
            fr:"Avec technologie Biotrate™",
            us_alt:"With Biotrate™ Technology"

          },
          {
            id:"headline-text",
            en:" is unique because it works against dental-associated bacteria by altering the mouths environment. It breaks through dental biofilm leaving bacteria otherwise inaccessible, exposed for eradication.",
            fr:" est unique parce qu'il agit contre les bactéries buccales associées à l’environnement, en le modifiant. Il passe au travers du biofilm dentaire rendant les bactéries inaccessibles, exposées pour éradication.",
            us_alt:" is unique because it works against dental-associated bacteria by altering the mouths environment. It breaks through dental biofilm leaving otherwise inaccessible bacteria exposed for eradication."

          },
          {
            id:"resources-headline",
            en:"Further resources for the Vetradent line.",
            fr:"",
            us_alt:"Further resources for the Vetradent Veterinary Dental line."

          },
          {
            id:"resources-text",
            en:"In addition to expert dental cleanings at your veterinary clinic, proper home dental care can be a great preventive when used according to a veterinarian’s instructions. Resources to help educate pet owners about the importance of home dental care and the home care options available from Vetradent™ can be found here.",
            fr:"",
            us_alt:"In addition to professional dental cleanings at your veterinarian’s office, proper home dental care can be a great preventive for serious dental issues when used according to your veterinarian’s instructions. Resources to help educate pet owners about the importance of home dental care and the home care options available from Vetradent™ can be found here."

          }


        ],

        products:[
          {
            content:[
              {
                id:"headline",
                en:"Vetradent™ Liquid Water Additive",
                fr:"Additif pour l’eau Vetradent™",
                us_alt:"Vetradent™ Liquid Water Additive"
              },
              {
                id:"subtext",
                en:"For Dogs & Cats",
                fr:"Pour les chiens et les chats",
                us_alt:"For Dogs & Cats"

              },
              {
                id:"product-tag",
                en:"Simply add to your pet’s drinking water every time you refill the bowl.",
                fr:"Ajoutez simplement à l’eau de votre animal chaque fois que vous remplissez son bol.",
                us_alt:"Simply add to your pet’s drinking water every time you refill the bowl."

              },
              {
                id:"product-closer",
                en:"Freshens breath.",
                fr:"Rafraîchit l’haleine.",
                us_alt:""

              },
              {
                id:"product-use",
                en:"Easy to use: Simply use the measuring cap to add 10 mL of Vetradent Water Additive per 250 mL of drinking water each time drinking water is added or replaced. Odourless, colourless and tasteless. Scientifically formulated to help fight plaque and tartar.",
                fr:"Facile à utiliser : il suffit d'utiliser le bouchon à doser pour ajouter 10 ml de l’additif pour l’eau Vetradent dans 250 ml d'eau potable à chaque fois que de l'eau est ajoutée ou remplacée. Inodore, incolore et sans goût. Scientifiquement formulé pour aider à combattre la plaque et le tartre.",
                us_alt:"Easy to use: Simply follow the dosing instructions listed on the bottle or carton each time the bowl is refilled. Odorless, colorless and tasteless."

              },
              {
                id:"product-ingredients",
                en:"Sodium Citrate, Citric Acid, Zinc Chloride",
                fr:"Citrate de Sodium, Acide Citrique, Chlorure de Zinc",
                us_alt:"Sodium Citrate, Citric Acid, Zinc Chloride"

              },
              {
                id:"product-package",
                en:"500 mL • NN.E5H1",
                fr:"500 ml • NN.E5H1",
                us_alt:"16.9 fl oz."

              },
              {
                id:"header1",
                en:"Active Ingredients",
                fr:"Ingrédients actifs ",
                us_alt:"Active Ingredients"
              },
              {
                id:"header2",
                en:"Package Size",
                fr:"Format",
                us_alt:"Package Size"
              },
              {
                id:"header3",
                en:"Documents",
                fr:"Documents",
                us_alt:""
              }
            ]
          },

          {
            content:[
              {
                id:"headline",
                en:"Vetradent™ Oral Spray",
                fr:"Vaporisateur Dentaire Vetradent™",
                us_alt:"Vetradent™ Oral Spray"
              },
              {
                id:"subtext",
                en:"For Dogs & Cats",
                fr:"Pour les chiens et les chats",
                us_alt:"For Dogs & Cats"

              },
              {
                id:"product-tag",
                en:"An alternative to Vetradent™ Water Additive, spray once or twice on each side of the mouth, twice a day.",
                fr:"Une alternative à l’additif pour l'eau Vetradent™ ; vaporisez une ou deux fois de chaque côté de la bouche, deux fois par jour.",
                us_alt:"An alternative to Vetradent™ Water Additive, follow dosing instructions on the label and spray on each side of the mouth, twice a day."

              },
              {
                id:"product-use",
                en:"The no-startle nozzle is unique and will not scare dogs or cats with a loud sound. Gently lift the upper lip to expose teeth and gum. For cats and dogs less than 9kg (20lb), spray once on each side of the mouth. For pets with larger mouths, typically those over 9kg (20lb), spray twice on each side of the mouth, coating teeth and gums well. Apply twice daily. A good option for pets on a raw diet or that don’t drink much water. Scientifically formulated to help fight plaque and tartar.",
                fr:"Conçu d’un diffuseur unique sans bruit il ne fera pas sursauter les chiens ni les chats. Soulevez légèrement la lèvre supérieure de votre animal pour exposer ses dents et ses gencives. Pour les chiens et les chats de moins de 9 kg, vaporisez un jet de chaque côté de la bouche. Pour les chiens ayant plus de 9 kg, vaporisez deux jets de chaque côté de la bouche pour bien couvrir les dents et les gencives. Appliquez deux fois par jour. Une bonne option pour les animaux de compagnie ayant un régime alimentaire cru ou qui ne boivent pas beaucoup d'eau. Scientifiquement formulé pour aider à combattre la plaque et le tartre.",
                us_alt:"The no-startle nozzle is unique and will not scare dogs or cats with a loud sound. Gently lift the upper lip and spray directly on the teeth and gums twice daily. For dogs and cats less than 20lbs, spray once on each side of the mouth. For pets with larger mouths (typically those over 20lbs), spray twice on each side of the mouth. Apply twice daily. Scientifically formulated to help fight plaque and tartar. A good option for pets on a raw diet that don’t drink much water. "

              },
              {
                id:"product-closer",
                en:"Freshens breath.",
                fr:"Rafraîchit l’haleine.",
                us_alt:"Freshens breath."

              },
              {
                id:"product-ingredients",
                en:"Sodium Citrate, Citric Acid, Zinc Chloride",
                fr:"Citrate de Sodium, Acide Citrique, Chlorure de Zinc",
                us_alt:"Sodium Citrate, Citric Acid, Zinc Chloride"

              },
              {
                id:"product-package",
                en:"60 mL • NN.X4K7",
                fr:"60 ml • NN.X4K7",
                us_alt:"60 mL"

              },
              {
                id:"header1",
                en:"Active Ingredients",
                fr:"Ingrédients actifs",
                us_alt:"Active Ingredients"
              },
              {
                id:"header2",
                en:"Package Size",
                fr:"Format",
                us_alt:"Package Size"
              },
              {
                id:"header3",
                en:"Documents",
                fr:"Documents",
                us_alt:"Documents"
              }
            ]
          },

          {
            content:[
              {

                id:"headline",
                en:"Vetradent™ Toothpaste",
                fr:"Dentifrice Vetradent",
                us_alt:""

              },
              {
                id:"subtext",
                en:"For Dogs & Cats",
                fr:"Pour les chiens et les chats",
                us_alt:""

              },
              {
                id:"product-tag",
                en:"Enhanced cleaning for healthy teeth and gums.",
                fr:"Nettoyage amélioré pour des dents et des gencives saines.",
                us_alt:"Enhanced cleaning for healthy teeth and gums, with a chicken flavor that's great for pets with food allergies. Simply use a pea sized amount of toothpaste on the included toothbrush and gently brush your pet’s teeth with a back and forth motion. No rinsing is required."

              },
              {
                id:"product-use",
                en:"Enhanced cleaning for healthy teeth and gums, with an artificial chicken flavour that's great for pets with food allergies. Simply use a pea sized amount of toothpaste on your pet’s toothbrush and gently brush your pet’s teeth with a back and forth motion.",
                fr:"Nettoyage amélioré pour des dents et des gencives saines, avec une saveur artificielle de poulet parfaite pour les animaux ayant des allergies alimentaires. Il suffit d'utiliser une quantité de dentifrice de la taille d’un pois sur la brosse à dents et de brossez doucement les dents de votre animal avec un léger mouvement de va-et-vient.",
                us_alt:"Enhanced cleaning for healthy teeth and gums, with a chicken flavor that's great for pets with food allergies. Simply use a pea sized amount of toothpaste on the included toothbrush and gently brush your pet’s teeth with a back and forth motion. No rinsing is required."

              },
              {
                id:"product-closer",
                en:"No rinsing is required.",
                fr:"Aucun rinçage n'est nécessaire.",
                us_alt:"Double headed toothbrush included"

              },
              {
                id:"product-ingredients",
                en:"Sodium Citrate, Citric Acid, Zinc Chloride",
                fr:"Citrate de Sodium, Acide Citrique, Chlorure de Zinc",
                us_alt:""

              },
              {
                id:"product-package",
                en:"65 g • NN.C6E8",
                fr:"65 g • NN.C6E8 ",
                us_alt:"2.3 oz tube"

              },
              {
                id:"header1",
                en:"Active Ingredients",
                fr:"Ingrédients actifs",
                us_alt:""
              },
              {
                id:"header2",
                en:"Package Size",
                fr:"Format",
                us_alt:""
              },
              {
                id:"header3",
                en:"Documents",
                fr:"Documents",
                us_alt:""
              }
            ]
          },

          {

            content:[
              {
                id:"headline",
                en:"Vetradent™ Dental Wipes",
                fr:"Lingettes Dentaires Vetradent™",
                us_alt:"Vetradent™ Dental Wipes"

              },
              {
                id:"subtext",
                en:"For Dogs & Cats",
                fr:"Pour les chiens et les chats",
                us_alt:"For Dogs & Cats"

              },
              {
                id:"product-tag",
                en:"Dental wipes are designed to aid in removing and preventing plaque build-up while freshening breath.",
                fr:"Lingettes dentaires conçues pour aider à éliminer et à prévenir l'accumulation de plaque et à rafraîchir l'haleine.",
                us_alt:"Dental wipes which are designed to decrease plaque build-up while freshening breath."

              },
              {
                id:"product-use",
                en:"Vetradent™ Dental Wipes are soft, disposable and have a texture to clean pets’ teeth and gums gently. Rub gently, but firmly, as directed by your veterinarian. Close the cap to keep wipes moist. Dental wipes for dogs and cats are a convenient method to keep your pet’s teeth free from plaque when on the go. They are suitable for dogs and cats of all ages, sizes, and breeds. Scientifically formulated to help fight plaque and tartar.",
                fr:"Les lingettes dentaires Vetradent™ sont douces, jetables et ont une texture pour nettoyer les dents et les gencives de votre un animal en douceur. Frottez doucement, mais fermement, tel que recommandé par votre vétérinaire. Fermez le couvercle hermétiquement  pour garder les lingettes humides. Les lingettes dentaires pour les chiens et les chats sont un moyen pratique pour garder les dents de votre animal sans plaque, lors de vos déplacements. Elles sont adaptées pour les chiens et les chats de tout âge, taille et race. Scientifiquement formulées pour aider à combattre la plaque et le tartre.",
                us_alt:"Vetradent™ Dental Wipes are soft, disposable and have a texture to clean pets’ teeth and gums gently. Dental wipes for dogs and cats are a convenient method to keep your pets’ teeth free from plaque when on the go. They are suitable for pets of all ages, sizes, and breeds. Freshens Breath."

              },
              {
                id:"product-closer",
                en:"Freshens Breath.",
                fr:"Rafraîchit l’haleine.",
                us_alt:"Freshens Breath."

              },
              {
                id:"product-ingredients",
                en:"Sodium Citrate, Citric Acid, Zinc Chloride",
                fr:"Citrate de Sodium, Acide Citrique, Chlorure de Zinc",
                us_alt:"Sodium Citrate, Citric Acid, Zinc Chloride"

              },
              {
                id:"product-package",
                en:"60 ct • NN. C1H3",
                fr:"60 lingettes • NN. C1H3",
                us_alt:"60 ct"

              },
              {
                id:"header1",
                en:"Active Ingredients",
                fr:"Ingrédients actifs",
                us_alt:"Active Ingredients"
              },
              {
                id:"header2",
                en:"Package Size",
                fr:"Format",
                us_alt:"Package Size"
              },
              {
                id:"header3",
                en:"Documents",
                fr:"Documents",
                us_alt:""
              }
            ]
          },

          {
            content:[
              {
                id:"headline",
                en:"Vetradent™ Powder Water Additive",
                fr:"Additif en poudre Vetradent™ pour l’eau",
                us_alt:"Vetradent™ Powder Water Additive"
              },
              {
                id:"subtext",
                en:"For Dogs & Cats",
                fr:"Pour les chiens et les chats",
                us_alt:"For Dogs & Cats"

              },
              {
                id:"product-tag",
                en:"An option for multiple and/or large dog households that comes in a concentrated powder form, to be pre-mixed before serving to your pet.",
                fr:"Une option, pour les foyers avec plusieurs et/ou gros chiens, qui se présente sous forme de poudre concentrée pour être pré-mélangée avant d’être servie à votre animal.",
                us_alt:"Dissolve into your pet’s drinking water every time you refill the bowl"

              },
              {
                id:"product-use",
                en:"Ideal for multi-pet households, or larger dogs that consume a lot of water. Add one scoop (6g) of Vetradent™ Powder to one litre of hot water. Mix until all powder dissolves, at least 30 seconds, and then allow water to cool before serving to your pet. Mix well before using. Vetradent™ is scientifically formulated to help fight plaque and tartar.",
                fr:"Idéale pour les foyers à plusieurs animaux, ou plus grands chiens qui consomment beaucoup d'eau. Ajoutez une mesure (6 g) de Vetradent™ en poudre à un litre (1 L) d'eau chaude. Mélangez jusqu'à ce que toute la poudre se dissout , au moins 30 secondes, puis laissez l'eau refroidir avant de la servir à votre animal. Bien mélangez avant l'utilisation. Vetradent™ est formulé scientifiquement pour aider à combattre la plaque et le tartre.",
                us_alt:" Great for households with multiple pets and large dogs. Follow the dosing instructions listed on the tub each time the bowl is refilled. Odorless, colorless and tasteless."

              },
              {
                id:"product-closer",
                en:"Freshens Breath.",
                fr:"Rafraîchit l’haleine.",
                us_alt:"Freshens Breath."

              },
              {
                id:"product-ingredients",
                en:"Sodium Citrate, Citric Acid, Zinc Citrate",
                fr:"Citrate de Sodium, Acide Citrique, Citrate de Zinc",
                us_alt:"Sodium Citrate, Citric Acid, Zinc Citrate"

              },
              {
                id:"product-package",
                en:"300 g • NN.R5T1",
                fr:"300 g • NN.R5T1",
                us_alt:"10.6 ounce tub"

              },
              {
                id:"header1",
                en:"Active Ingredients",
                fr:"Ingrédients actifs",
                us_alt:"Active Ingredients"
              },
              {
                id:"header2",
                en:"Package Size",
                fr:"Format",
                us_alt:"Package Size"
              },
              {
                id:"header3",
                en:"Documents",
                fr:"Documents",
                us_alt:"Documents"
              }
            ]
          },
          {
            content:[
              {
                id:"headline",
                en:"Vetradent™ Rawhide Dental Chews for Dogs (Medium)",
                fr:"Additif en poudre Vetradent™ pour l’eau",
                us_alt:"Vetradent™ Rawhide Dental Chews for Dogs (Medium)"
              },
              {
                id:"subtext",
                en:"",
                fr:"",
                us_alt:"For dogs 11-25 lb"

              },
              {
                id:"product-tag",
                en:"This chew is made with a naturally abrasive beef rawhide and treated with Biotrate™ Technology to promote good oral hygiene through a chewing action with helps to freshen breath and fight tartar.",
                fr:"",
                us_alt:""

              },
              {
                id:"product-use",
                en:"This chew is made with a naturally abrasive beef rawhide and treated with Biotrate™ Technology to promote good oral hygiene through a chewing action with helps to freshen breath and fight tartar.",
                fr:"",
                us_alt:""

              },
              {
                id:"product-closer",
                en:"Freshens Breath.",
                fr:"Rafraîchit l’haleine.",
                us_alt:"Freshens Breath."

              },
              {
                id:"product-ingredients",
                en:"Sodium Citrate, Citric Acid, Zinc Citrate",
                fr:"Citrate de Sodium, Acide Citrique, Citrate de Zinc",
                us_alt:"Sodium Citrate, Citric Acid, Zinc Citrate"

              },
              {
                id:"product-package",
                en:"",
                fr:"",
                us_alt:"30 rawhides per bag"

              },
              {
                id:"header1",
                en:"Active Ingredients",
                fr:"Ingrédients actifs",
                us_alt:"Active Ingredients"
              },
              {
                id:"header2",
                en:"Package Size",
                fr:"Format",
                us_alt:"Package Size"
              },
              {
                id:"header3",
                en:"Documents",
                fr:"Documents",
                us_alt:"Documents"
              }
            ]
          },
          {
            content:[
              {
                id:"headline",
                en:"Vetradent™ Rawhide Dental Chews for Dogs (Large)",
                fr:"Additif en poudre Vetradent™ pour l’eau",
                us_alt:"Vetradent™ Rawhide Dental Chews for Dogs (Large)"
              },
              {
                id:"subtext",
                en:"",
                fr:"",
                us_alt:"For dogs 26-65 lb"

              },
              {
                id:"product-tag",
                en:"This chew is made with a naturally abrasive beef rawhide and treated with Biotrate™ Technology to promote good oral hygiene through a chewing action with helps to freshen breath and fight tartar.",
                fr:"",
                us_alt:""

              },
              {
                id:"product-use",
                en:"This chew is made with a naturally abrasive beef rawhide and treated with Biotrate™ Technology to promote good oral hygiene through a chewing action with helps to freshen breath and fight tartar.",
                fr:"",
                us_alt:""

              },
              {
                id:"product-closer",
                en:"Freshens Breath.",
                fr:"Rafraîchit l’haleine.",
                us_alt:"Freshens Breath."

              },
              {
                id:"product-ingredients",
                en:"Sodium Citrate, Citric Acid, Zinc Citrate",
                fr:"Citrate de Sodium, Acide Citrique, Citrate de Zinc",
                us_alt:"Sodium Citrate, Citric Acid, Zinc Citrate"

              },
              {
                id:"product-package",
                en:"",
                fr:"",
                us_alt:"30 rawhides per bag"

              },
              {
                id:"header1",
                en:"Active Ingredients",
                fr:"Ingrédients actifs",
                us_alt:"Active Ingredients"
              },
              {
                id:"header2",
                en:"Package Size",
                fr:"Format",
                us_alt:"Package Size"
              },
              {
                id:"header3",
                en:"Documents",
                fr:"Documents",
                us_alt:"Documents"
              }
            ]
          },

        ]

      },
      {
        id:4,
        en:"About",
        fr:"À propos",
        us_alt:"About",

        content:[
          {
            id:"headline",
            en:"Continuing a legacy of excellence",
            fr:"Poursuivant une tradition d'excellence",
            us_alt:"Continuing a legacy of excellence"
          },
          {
            id:"headline-text",
            en:"Dechra Veterinary Products has partnered with Kane Biotech to bring the Vetradent™ line to veterinarians and pet owners in North America.\n\nThis builds upon Dechra’s history of commitment to the veterinary health industry which dates back to 1819.",
            fr:"Les Produits Vétérinaires Dechra se sont associés à Kane Biotech pour introduire la ligne de Vetradent™ aux vétérinaires et aux propriétaires d'animaux d’Amérique du Nord.\n\nTout cela s'ajoute à l’historique d’engagement de Dechra à  l’industrie en santé animale datant depuis 1819.",
            us_alt:"Dechra Veterinary Products has partnered with Kane Biotech to bring the Vetradent™ Veterinary Dental line to veterinary clinics and pet owners in North America.\n\nThis builds upon Dechra’s history of commitment to the veterinary health industry which dates back to 1819."
          },
          {
            id:"dechra-headline",
            en:"Dechra",
            fr:"Dechra",
            us_alt:"Dechra"
          },
          {
            id:"dechra-text",
            en:"We are an international specialist in veterinary pharmaceuticals and related products business. Our expertise is in the development, manufacturing, sales and marketing of high quality products exclusively for veterinarians worldwide.",
            fr:"Nous sommes une compagnie internationale spécialisée en produits pharmaceutiques vétérinaires et produits connexes. Notre expertise est dans le développement, la fabrication, la vente et la commercialisation de produits de haute qualité exclusivement pour les vétérinaires à travers  le monde.",
            us_alt:"We are an international specialist veterinary pharmaceuticals and related products business. Our expertise is in the development, manufacturing, sales and marketing of high quality products exclusively for veterinarians worldwide."
          },
          {
            id:"history-headline",
            en:"History",
            fr:"Historique",
            us_alt:"History"
          },
          {
            id:"history-text",
            en:"Dechra has a long history in the veterinary health market dating back to 1819, when the company was established as Arnolds & Son, originally manufacturing prosthetic limbs. The company first turned its attention to veterinary medicine during the Crimean War.",
            fr:"Dechra a un long historique sur le marché de santé vétérinaire datant de 1819, lorsque la compagnie a été établie sous le nom d’Arnolds & Son, fabriquant, à l'origine, des membres artificiels. C’est durant la guerre de Crimée que l'entreprise a porté son attention sur la médecine vétérinaire.",
            us_alt:"Dechra has a long history in the veterinary health market dating back to 1819, when the company was established as Arnolds & Son, originally manufacturing prosthetic limbs. The company first turned its attention to veterinary medicine during the Crimean War."
          },
          {
            id:"visit-dechra",
            en:"Visit the Dechra Site.",
            fr:"Visitez le site Dechra.",
            us_alt:"Visit the Dechra Site."
          },
          {
            id:"visit-dechra-url",
            class:"url",
            en:"https://www.dechra.ca/",
            fr:"https://www.dechra.ca/",
            us_alt:"https://www.dechra.com/"
          },

        ]

      }

    ];

    this.footer=[
      {
        id: "customerServiceContactInfoLabel",
        en: "Customer Service",
        fr: "Service à la clientele",
        us_alt: "Customer Service"
      },
      {
        id: "customerServiceContactInfo",
        en: "Technical.ca@dechra.com or call: (855) 332-9334",
        fr: "technical.ca@dechra.com ou appelez-nous au : (855) 332-9334",
        us_alt: "support@dechra.com or call: (866) 933-2472"
      },
      {
        id:"dechraSiteUrl",
        class:"url",
        en:"https://www.dechra.ca/",
        fr:"https://www.dechra.ca/",
        us_alt:"https://www.dechra.com/"
      },
      {
        id:"dechraSiteUrlText",
        en:"Visit the Dechra Corporate website",
        fr:"Visitez le site Dechra",
        us_alt:"Visit the Dechra Corporate website"
      }
    ];

    this.headlines=[
      {id:0,
        en:"Continuing a legacy of excellence",
        fr:"Poursuivre un héritage d'excellence"}
    ];

    this.blocktext=[
      {id:0,
        en:"Dechra Veterinary Products has partnered with Kane Biotech to bring the Vetradent line to veterinary clinics and pet owners in countries accross the globe. \n \n This builds upon Dechra's history of commitment to the veterinary health industry which dates back to 1819",
        fr:"Dechra Veterinary Products a conclu un partenariat avec Kane Biotech pour apporter la ligne Vetradent aux cliniques vétérinaires et aux propriétaires d'animaux domestiques dans les pays du monde entier. \n \n Cela s'appuie sur l'engagement de Dechra envers l'industrie de la santé vétérinaire qui remonte à 1819"
      }

    ];
  }
}

export default Content


// WEBPACK FOOTER //
// ./src/Content.js